export default "__VITE_ASSET__8m4Iyigj__"